<template>
  <div class="ordersucceed">
    <GlobTopNav title="兑换成功"></GlobTopNav>

    <!-- <img class="ordersucceed-bg" src="./../../assets/img/dhcg.png" alt=""> -->

    <div class="pop" v-if="lodingshow"><van-loading type="spinner" /></div>

    <div class="van-content">
      <div class="title">
        <img src="./../../assets/img/dhcg-icon.png" alt="" />
        <span>兑换成功</span>
        <p v-if="dummy != 2 && dummy != 3" class="ft16">我们将第一时间为您发货！</p>
        <p v-if="dummy == 2" class="ft14">系统将尽快为您充值！</p>
        <p v-if="dummy == 3" class="ft14">系统将尽快为您发送兑换码！</p>
      </div>

      <div class="ordersucceed-cont">
        <div v-if="dummy != 2 && dummy != 3" class="order-cell">
          <span class="div-text"> 收&#8194;货&#8194;人：</span>
          <span class="div-right">{{ datas.consignee }} {{ datas.mobile }}</span>
        </div>
        <div v-if="dummy == 3" class="order-cell">
          <span class="div-text">收货人手机：</span>
          <span class="div-right">{{ datas.mobile }}</span>
        </div>
        <div v-if="dummy == 2" class="order-cell">
          <span class="div-text">通知号码：</span>
          <span class="div-right">{{ datas.mobile }}</span>
        </div>
        <div v-if="dummy == 3 || dummy == 2" class="order-cell">
          <span class="div-text">商品名称：</span>
          <span class="div-right">{{ datas.goodsname }}</span>
        </div>
        <div v-if="dummy==2">
          <div v-for="(items,index) in datas.exp_param" :key="index"  class="order-cell">
            <span class="div-text">{{items.title}}：</span>
            <span class="div-right">{{ items.value}}</span>
          </div>
        </div>

        <div v-if="dummy != 2 && dummy != 3" class="order-cell">
          <span class="div-text"> 收货地址： </span>
          <span class="div-right">
            {{ datas.str_province }}{{ datas.str_city }}{{ datas.str_county }}{{ datas.str_town
            }}{{ datas.str_address }}
          </span>
          <!--http://www.pointscloud.wap.com:8070/ordersucceed?orderId=201812201118301050-->
        </div>
        <div class="order-cell">
          <span class="div-text">订单编号：</span>
          <span class="div-right">{{ this.orderID }}</span>
        </div>
        <div class="order-cell">
          <span class="div-text">下单时间：</span>
          <span class="div-right">{{ time(datas.time) }}</span>
        </div>

        <div class="order-cell">
          <span class="div-text">交易金额：</span>
          <span class="div-right">
            <span v-if="datas.totalpoint">{{ datas.totalpoint }}{{ unit }}</span>
            <span v-if="datas.total_cash"><span v-if="datas.totalpoint">+</span>{{ datas.total_cash }}元 </span>
          </span>
        </div>
        <div v-if="dummy != 2 && dummy != 3" class="order-cell">
          <span class="div-text"> 订单备注： </span>
          <span class="div-right" v-html="datas.remark == '' ? '无' : datas.remark"></span>
        </div>

        <div class="order-btn">
          <van-button @click="goHome()" class="go-home"> 返回首页 </van-button>
          <van-button @click="godetail()" class="view-order theme-bd theme-bg">
            查看订单
          </van-button>
        </div>
      </div>
    </div>
    <!--<footer-nav></footer-nav>-->
  </div>
</template>

<script>
import FooterNav from "@/components/footernav";
import TopNav from "../../components/topnav";
export default {
  name: "ordersucceed",
  components: {
    FooterNav,
    TopNav
  },
  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    }
  },
  data() {
    return {
      orderID: this.$route.query.orderId,
      datas: "",
      dummy: "",
      lodingshow: true
    };
  },
  methods: {
    godetail: function() {
      this.$router.push({ path: "/user/myorder/allorder" });
    },
    goHome: function() {
      this.$router.push({ path: "/" });
    },
    goBack: function() {
      history.back(-1);
    },
    time: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$api.get(
        "order/orders/payinfo",
        { id_example: mallid, token_user: isUser, ordersn: this.orderID },
        res => {
          this.dummy = res.data.data.source;
          this.datas = res.data.data;
          this.lodingshow = false;
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    }
  },
  mounted() {
    this.getDatas();
  }
};
</script>

<style lang="less" scoped>
.ordersucceed {
  min-height: 100vh;
  background: #f5f5f5;
  position: relative;
  background-image: url("./../../assets/img/dhcg.png");
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: 0 0.9rem;

  .ordersucceed-bg {
    width: 100%;
    position: absolute;
    z-index: 1;
  }

  .van-content {
    width: 100%;
    position: relative;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0);
  }

  .title {
    width: calc(100% - 0.6rem);
    border-radius: 0.24rem;
    height: 3.02rem;
    background: #fff;
    margin: 1.3rem auto 0.2rem auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 0.88rem;
      height: 0.88rem;
    }

    span {
      font-size: 0.36rem;
      font-weight: 500;
      color: #262626;
      line-height: 0.5rem;
      margin-top: 0.1rem;
      margin-bottom: 0.16rem;
    }

    p {
      font-size: 0.28rem;
      font-weight: 400;
      color: rgba(38, 38, 38, 0.5);
      line-height: 0.48rem;
    }
  }
  .ordersucceed-cont {
    width: 6.9rem;
    height: auto;
    background: #ffffff;
    border-radius: 0.24rem;
    margin: 0 auto;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0.2rem 0.3rem 0.5rem 0.3rem;

    .order-cell {
      width: 100%;
      padding: 0.2rem 0;
      display: flex;

      .div-text {
        display: inline-block;
        width: 1.8rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.5);
        line-height: 0.48rem;
        text-align: justify;
        text-align-last: justify;
      }

      .div-right {
        flex: 1;
        padding-left: 0.1rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.5);
        line-height: 0.48rem;
      }
    }

    .order-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.2rem;

      .go-home {
        width: 2.9rem;
        height: 0.96rem;
        background: #fdf5f5;
        border-radius: 0.5rem;
        border: 0.02rem solid #e23331;
        font-size: 0.3rem;
        font-weight: 500;
        color: #e23331;
        line-height: 0.42rem;
        .van-button__content {
          color: #e23331;
        }
      }

      .view-order {
        width: 3.2rem;
        height: 0.96rem;
        background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
        border-radius: 0.48rem;
        font-size: 0.3rem;
        font-weight: 500;
        color: #ffffff;
        line-height: 0.42rem;
      }
    }
  }

  .pop {
    background-color: #fff !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    .van-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -0.3rem 0 0 -0.3rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/affirmorder/ordersucceed.vue